<template>
  <div>
    <b-row>
      <b-col v-if="!basicInfo">
        <b-row class="profile-row">
          <template v-if="!isLoading">
            <b-col>
              <img
                v-if="!student || !student.User || !student.User.photo"
                src="@/assets/images/default-photo.png"
                height="64"
                width="64"
                alt
              />
              <img
                v-else
                width="64"
                height="64"
                :src="`${student.User.photo}`"
                alt
              />
              <div class="content-meeting">
                <div class="student-detail">
                  <h5>{{ student && student.User && student.User.name }}</h5>
                  <p v-if="cycle && cycle.designation">
                    {{ cycle.designation }}
                    <template>
                      ({{ year && year.designation }} º ano no ciclo)
                    </template>
                    <br />
                    <template>
                      Frequência total do ano: {{ attendances.frequency }}%
                    </template>
                  </p>
                </div>
              </div>
            </b-col>
            <b-col>
              <div class="content-meeting">
                <div class="column">
                  <p>
                    <b>Carga horária anual</b>
                  </p>
                  <p v-if="cycle && cycle.workload">{{ cycle.workload }}h</p>
                </div>
                <div class="column">
                  <p>
                    <b>Limite permitido de faltas</b>
                  </p>
                  <p v-if="cycle && cycle.absence_limit_hours">
                    {{ cycle.absence_limit_hours }}h
                  </p>
                </div>
                <div class="column">
                  <p>
                    <b>Total de faltas/atrasos do aluno</b>
                  </p>
                  <p>
                    {{
                      attendances.time_absences
                        ? attendances.time_absences
                        : "0h"
                    }}
                  </p>
                </div>
              </div>
            </b-col>
          </template>
          <template v-else>
            <b-col class="d-flex justify-content-center align-items-center">
              <b-spinner label="Loading..."></b-spinner>
            </b-col>
          </template>
        </b-row>
      </b-col>
      <b-col v-else>
        <b-row class="profile-row">
          <template v-if="!isLoading">
            <b-col >
              <div class="content-meeting" style="align-items: center;">
              <img
                v-if="!student || !student.User || !student.User.photo"
                src="@/assets/images/default-photo.png"
                height="64"
                width="64"
                alt
              />
              <img
                v-else
                width="64"
                height="64"
                :src="`${student.User.photo}`"
                alt
              />
              <div class="student-detail" style="justify-content: space-between; flex-direction: row;">
                <h5>{{ student && student.User && student.User.name }}</h5>
                <p v-if="cycle && cycle.designation">
                {{ cycle.designation }}
                <template>
                  ({{ year && year.designation }} º ano no ciclo)
                </template>
                </p>
              </div>
              </div>
            </b-col>
          </template>
          <template v-else>
            <b-col class="d-flex justify-content-center align-items-center">
              <b-spinner label="Loading..."></b-spinner>
            </b-col>
          </template>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DataServiceStudents from "@/services/students.service";
import httpRda from "../http-rda";

export default {
  name: "StudentProfileCard",
  data() {
    return {
      attendances: {},
      student: {},
      cycle: {},
      year: {},
      isLoading: false,
    };
  },
  props: {
    studentId: {
      type: Number,
    },
    basicInfo: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.isLoading = true;
    httpRda
      .get(`/students/${this.studentId}?include=parents,cycle`)
      .then(async (res) => {
        this.student = res.data.student;
        this.cycle = res.data.student.Classroom.Cycle;
        this.year = res.data.student.Classroom.Year;
      })
      .catch(() => {
        this.isLoading = false;
      });

    DataServiceStudents.getStudentAttendances(this.studentId)
      .then((response) => {
        this.attendances = response.data;
      })
      .catch(() => {
        this.isLoading = false;
      });

    this.isLoading = false;
  },
};
</script>

<style scoped lang="scss">
.profile-row {
  background: -webkit-linear-gradient(left, #36b67d, #6883c5);
  border-radius: 10px;
  color: #fff;
  margin-top: 30px;
  padding: 28px 10px;
  position: relative;
  width: 100%;
  flex-wrap: nowrap;
  padding-left: 15px;

  &:after {
    content: none;
    right: 0;
    pointer-events: none;
    position: absolute;
    top: -5px;
  }

  .col {
    display: flex;
    align-items: center;

    img {
      margin-right: 40px;
    }
  }
}

.attendance-advice {
  background-color: #ef6549;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 10px 10px;
  display: flex;
  align-self: center;
  justify-self: center !important;

  p {
    color: #fff;
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 1px;
  }
}

.col {
  display: flex;
  align-items: center;

  img {
    margin-right: 40px;
  }

  .content-meeting {
    display: flex;
    flex-direction: row;
    gap: 32px;
    width: 100%;

    h5 {
      font-size: 18px;
      white-space: nowrap;
      margin: 0;
    }

    .column {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-between;
      gap: 4px;
      width: 100%;

      p {
        margin: 0;
        font-weight: 400;
        white-space: nowrap;
        font-size: 18px;
        white-space: normal;
        word-break: break-word;
      }

      &.two {
        min-width: 650px;
      }
    }

    .student-detail {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      text-align: left;

      @media (max-width: 1310px) {
        max-width: 300px;
      }

      p {
        font-size: 18px;
        white-space: nowrap;
        margin: 0;
      }
    }
  }
}
</style>
